import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../app/store'
import SectionBoxContainer from '../../components/SectionBoxContainer'
import ItemsApp, { EmptyItemModel, IInventoryModel, IItemModel } from './ItemsApp'
import { useDispatch } from 'react-redux'
import { handleRequestError } from '../../services/api'
import { updateInventoryItemList, updateInventoryItemListLoading, updateInventoryItemListRefresh, updateNewStockDetails, updateNewStockModalStatus, updateReduceStockStatus } from './itemsSlice'
import { Avatar, Button, Skeleton } from '@mui/material'
import NothingFound from '../../components/NothingFound'
import { updateTransactionSavedDetails, updateTransactionTiggerModal } from '../transactions/transactionsSlice'
import GenerateIcon from '../../components/GenerateIcon'
import UnauthorizedBlock from '../../components/UnauthorizedBlock'
import NewStock from './NewStock'
import AlertElement from '../../components/AlertElement'
import Thumbnail from '../../components/Thumbnail'

interface IProps {
    itemUniqueId: string,
    usePublicDetails?: boolean,
    disableActionButtons?: boolean,
    displayOnlyRecords?: boolean,
    isContainer?: boolean,
    containerId?: number | null,
    customButtons?: (inventory: IInventoryModel) => JSX.Element
}

interface ISingleItemInventoryBoxProps extends IInventoryModel{
    disableActionButtons?: boolean,
    isContainer?: boolean,
    customButtons?: (inventory: IInventoryModel) => JSX.Element,
    viewRequestPage?: boolean,
}

export function SingleItemInventoryBox(props: ISingleItemInventoryBoxProps) {

    const dispatch = useDispatch()

    const { warehouse, section, location, user, quantity, warehouse_id, section_id, location_id, user_id, item, thumbnail, isContainer, customButtons, viewRequestPage, reserved_quantity } = props

    const [transactionType, setTransactionType] = useState<string>("")
    const [transactionAction, setTransactionAction] = useState<string>("")

    let disableActionButtons = viewRequestPage ? true : props.disableActionButtons

    /**
     * Render content
     */
    const renderContent = () => {

        type TypeOfEntry = "warehouse" | "location" | "user"

        let type: TypeOfEntry = "warehouse"

        if (location){
            type = "location"
        }

        if (user){
            type = "user"
        }

        switch(type){

            case "warehouse":
                return(
                    <>
                        <div className="info-box-of-single-transcation-order" style={{ minWidth: 150, maxWidth: 150 }}>
                            <div className="content-of-info-box-of-single-transcation-order">
                                <h3>Warehouse:</h3>
                                <p>{warehouse}</p>
                            </div>
                        </div>

                        <div className="info-box-of-single-transcation-order" style={{ minWidth: 150, maxWidth: 150 }}>
                            <div className="content-of-info-box-of-single-transcation-order">
                                <h3>Section:</h3>
                                <p>{section}</p>
                            </div>
                        </div>
                    </>
                )

            case "location":
                return(
                    <div className="info-box-of-single-transcation-order" style={{ minWidth: 330, maxWidth: 330 }}>
                        <div className="content-of-info-box-of-single-transcation-order">
                            <h3>Location:</h3>
                            <p>{location}</p>
                        </div>
                    </div>
                )

            case "user":
                return(
                    <div className="info-box-of-single-transcation-order" style={{ minWidth: 330, maxWidth: 330 }}>
                        <div className="content-of-info-box-of-single-transcation-order">
                            <h3>User:</h3>
                            <p>{user}</p>
                        </div>
                    </div>
                )

            default: 
                return <></>
        }

    }

    /**
     * Trigger transcation modal
     */
    const triggerTransactionModal = () => dispatch(updateTransactionTiggerModal(true))

    /**
     * Update Transaction details
     */
    const updateTranscationDetails = () => dispatch(updateTransactionSavedDetails({
        fromWarehouse: warehouse_id,
        fromSection: section_id,
        fromLocation: location_id,
        fromUser: user_id,
        itemId: item,
        type: transactionType,
        action: transactionAction,
        fromType: transactionType,
    }))

    /**
     * Transfer
     */
    const transfer = () => {
        updateTranscationDetails()
        triggerTransactionModal()
    }

    /**
     * New stock
     */
    const newStock = (reduceStock: boolean = false) => {
        if (reduceStock){
            dispatch(updateReduceStockStatus(true))
        }else{
            dispatch(updateReduceStockStatus(false))
        }

        dispatch(updateNewStockDetails({
            item_id: item,
            warehouse_id: warehouse_id,
            section_id: section_id,
            location_id: location_id,
            user_id: user_id,
            quantity: 1,
            timestamp: "",
            note: "",
            available_quantity: quantity
        }))
        dispatch(updateNewStockModalStatus(true))
    }

    /**
     * Define transcation action and type
     */
    useEffect(() => {

        let type: string = ""
        let action: string = "transferred"

        if (warehouse_id){
            type = "to-warehouse"
        }

        if (location_id){
            type = "to-location"
        }

        if (user_id){
            type = "with-user"
        }

        setTransactionAction(action)
        setTransactionType(type)

    }, [props])

    const isReduceStockDisabled = () => {
        // isContainer ? true : quantity == 1 ? true : false

        if(isContainer){
            return true
        }

        if (quantity === 0){
            return true
        }

        return false
    }

    return(
        <div className="single-transcation-order">
            <div className="content-of-single-transcation-order">

                <NewStock />

                <div className="boxes-of-single-transcation-order">
                    <div className="content-of-boxes-of-single-transcation-order">

                        <div className="info-box-of-single-transcation-order" style={{ maxWidth: 50, minWidth: 50 }}>
                            <div className="content-of-info-box-of-single-transcation-order">
                                {/* <Avatar src={thumbnail} style={{ width: 50, height: 50 }}>
                                    <GenerateIcon icon="image" />
                                </Avatar> */}
                                <Thumbnail src={thumbnail} style={{ width: 50, height: 50 }} />
                            </div>
                        </div>

                        {renderContent()}

                        <div className="info-box-of-single-transcation-order">
                            <div className="content-of-info-box-of-single-transcation-order">
                                <h3>Available Qnt.</h3>
                                <p>{quantity}</p>
                            </div>
                        </div>


                        <div className="info-box-of-single-transcation-order">
                            <div className="content-of-info-box-of-single-transcation-order">
                                <h3>Reserved Qnt.</h3>
                                <p>{reserved_quantity}</p>
                            </div>
                        </div>

                    </div>
                </div>

                {!disableActionButtons && (
                    <div className="buttons-of-single-transcation-order">
                        <div className="content-of-buttons-of-single-transcation-order">
                            
                            {customButtons ? customButtons(props) : (
                                <>
                                    {/* <Button disabled={quantity > 0 ? false : true} style={{ height: 45 }} className="general-button" color="info" variant="text" onClick={() => transfer()}>Transfer</Button> */}
                                    <Button disabled={isContainer ? true : false} style={{ height: 45 }} className="general-button" color="success" variant="text" onClick={() => newStock()}>New Stock</Button>
                                    <Button disabled={isReduceStockDisabled()} style={{ height: 45 }} className="general-button" color="error" variant="text" onClick={() => newStock(true)}>Reduce Stock</Button>
                                </>
                            )}

                        </div>
                    </div>
                )}

            </div>
        </div>
    )
}

export default function ItemInventory(props: IProps) {

    const dispatch = useDispatch()

    const { itemUniqueId, usePublicDetails, disableActionButtons, displayOnlyRecords, isContainer, containerId, customButtons } = props
    const { loading, list, refresh } = useSelector((state: RootState) => state.items.inventory)

    const itemsApp = new ItemsApp()

    const [containerItem, setContainerItem] = useState<IItemModel | null>(null)

    /**
     * Update list
     */
    const updateList = (list: IInventoryModel[]) => dispatch(updateInventoryItemList(list))

    /**
     * Update loading
     */
    const updateLoading = (status: boolean) => dispatch(updateInventoryItemListLoading(status))

    /**
     * Trigger inventory list refresh
     */
    const triggerInventoryListRefresh = (status: boolean) => dispatch(updateInventoryItemListRefresh(status))

    /**
     * Load list
     */
    const loadList = () => {
        updateLoading(true)

        itemsApp.itemInventory(itemUniqueId)
            .then(response => {
                updateList(response.data)
                updateLoading(false)
            })
            .catch(error => {
                handleRequestError(error, dispatch)
                updateLoading(false)
            })
    }

    /**
     * Render loading items
     */
    const renderLoadingItems = () => {
        return(
            <>
                <Skeleton variant="rectangular" width="100%" height={100} style={{ marginBottom: 10 }}/>
                <Skeleton variant="rectangular" width="100%" height={100} style={{ marginBottom: 10 }} />
                <Skeleton variant="rectangular" width="100%" height={100} style={{ marginBottom: 10 }} />
                <Skeleton variant="rectangular" width="100%" height={100} style={{ marginBottom: 10 }} />
                <Skeleton variant="rectangular" width="100%" height={100} style={{ marginBottom: 10 }} />
            </>
        )
    }

    /**
     * Load inventory
     */
    useEffect(() => {
        if (!usePublicDetails){
            if (itemUniqueId){
                loadList()
            }
        }
    }, [itemUniqueId])

    /**
     * 
     */
    useEffect(() => {
        if (!usePublicDetails){
            if (refresh){
                triggerInventoryListRefresh(false)
                loadList()
            }
        }
    }, [refresh])

    /**
     * Load container item
     */
    useEffect(() => {
        if (containerItem === null && containerId){
            updateLoading(true)

            itemsApp.singleInstanceDetails(containerId)
                .then(response => {
                    setContainerItem(response.data)
                    updateLoading(false)
                })
                .catch(error => {
                    updateLoading(false)
                    handleRequestError(error, dispatch)
                })
        }
    }, [containerId])

    /**
     * Render container item
     */
    const renderContainerItem = () => {

        if (containerId && containerItem !== null){

            return(
                <div>

                    <div className="single-transcation-order">
                                <div className="content-of-single-transcation-order">

                                    <div className="boxes-of-single-transcation-order">
                                        <div className="content-of-boxes-of-single-transcation-order">

                                            <div className="info-box-of-single-transcation-order" style={{ maxWidth: 50, minWidth: 50 }}>
                                                <div className="content-of-info-box-of-single-transcation-order">
                                                    {/* <Avatar src={containerItem.thumbnail} style={{ width: 50, height: 50 }}>
                                                        <GenerateIcon icon="image" />
                                                    </Avatar> */}
                                                    <Thumbnail src={containerItem.thumbnail} style={{ width: 50, height: 50 }} />
                                                </div>
                                            </div>

                                            <div className="info-box-of-single-transcation-order" style={{ maxWidth: 200, minWidth: 200 }}>
                                                <div className="content-of-info-box-of-single-transcation-order">
                                                    <h3>Container</h3>
                                                    <p><a href={`/panel/items/view/${containerItem.id}`}>{containerItem.title}</a></p>
                                                </div>
                                            </div>

                                            <div className="info-box-of-single-transcation-order" style={{ minWidth: 200, maxWidth: 200 }}>
                                                <div className="content-of-info-box-of-single-transcation-order">
                                                    <h3>Unique ID:</h3>
                                                    <p>{containerItem.unique_id}</p>
                                                </div>
                                            </div>

                                            <div className="info-box-of-single-transcation-order" style={{ minWidth: 200, maxWidth: 200 }}>
                                                <div className="content-of-info-box-of-single-transcation-order">
                                                    <h3>Serial Number:</h3>
                                                    <p>{containerItem.serial_number ? containerItem.serial_number : "-"}</p>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                </div>
                    </div>

                    <div style={{ marginTop: 10 }}>
                        <AlertElement type="info" message={`The item is a part of the container - ${containerItem.title}`} />
                    </div>

                </div>
            )
        }

        return <></>
    }

    /**
     * Render items
     */
    const renderItems = () => {

        if (containerId && containerItem){
            return renderContainerItem()
        }

        return usePublicDetails ? <UnauthorizedBlock title="Unauthorized" message="You have to sign-in to your account in order to view the information." buttons={[ { label: "Sign-in", link: "/sign-in", color: "error" } ]} /> : loading ? renderLoadingItems() : list.length > 0 ? list.map((item, index) => <SingleItemInventoryBox {...item} key={index} disableActionButtons={disableActionButtons} isContainer={isContainer} customButtons={customButtons} />) : <NothingFound title="Nothing..." message="No records have been found" />

    }

    if (displayOnlyRecords){
        return <>{renderItems()}</>
    }

    return(
        <div className="item-inventory-block-container">
            <SectionBoxContainer
                showTitle
                title="Where item is now"
                description="Here you can see the item current warehouse/section/location"
            >
                <div className="all-item-inventory-locations-container">
                    <div className="content-of-all-item-inventory-locations-container">
                        {renderItems()}
                    </div>
                </div>
            </SectionBoxContainer>
        </div>
    )
}